// Copyright 2026 Hardfin, Inc.
// Hardfin Confidential - Restricted
// Dialog wrapper for the company data CSV import workflow.
// Provides a full-width dialog containing the multi-step upload component.
import { CompanyDataUpload } from '@/customer/components/company-data-upload';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * Full-width dialog for importing company data from a CSV file.
 *
 * @param props.isOpen - Whether the dialog is currently visible
 * @param props.onClose - Callback to close the dialog
 */
export function CompanyDataImportDialog(props: Props) {
  return (
    <Dialog fullWidth maxWidth="lg" open={props.isOpen} onClose={props.onClose}>
      <DialogTitle>Upload company data</DialogTitle>
      <DialogContent dividers>
        <CompanyDataUpload onClose={props.onClose} />
      </DialogContent>
    </Dialog>
  );
}
